import React, { useEffect, useState } from 'react';
import { Card, CardContent } from '../components/ui/card';
import { API } from '../lib/api';
import { formatDateTime } from '../lib/brand';

export default function AdminCustomers() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    (async () => {
      try { const { data } = await API.get('/admin/customers'); setItems(data); }
      finally { setLoading(false); }
    })();
  }, []);
  return (
    <div className="space-y-4" data-testid="admin-customers">
      <h1 className="font-heading font-semibold text-2xl text-[hsl(var(--primary))]">Kunden</h1>
      <Card className="rounded-2xl border-slate-200">
        <CardContent className="p-0">
          <div className="overflow-x-auto">
            <table className="w-full text-sm" data-testid="admin-customers-table">
              <thead className="bg-slate-50"><tr className="text-left text-slate-600"><th className="px-4 py-3">Name</th><th className="px-4 py-3">E-Mail</th><th className="px-4 py-3">Telefon</th><th className="px-4 py-3">Registriert</th></tr></thead>
              <tbody>
                {loading ? <tr><td colSpan={4} className="px-4 py-6 text-slate-500">Lade...</td></tr> : items.length === 0 ? <tr><td colSpan={4} className="px-4 py-6 text-slate-500">Keine Kunden.</td></tr> : items.map((u) => (
                  <tr key={u.id} className="border-t border-slate-100 hover:bg-slate-50">
                    <td className="px-4 py-3">{u.first_name} {u.last_name}</td>
                    <td className="px-4 py-3">{u.email}</td>
                    <td className="px-4 py-3">{u.phone || '-'}</td>
                    <td className="px-4 py-3 text-slate-500">{formatDateTime(u.created_at)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
